import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import appReducer from "./slices/app";
import filterReducer from "./slices/filter";
import favoritesReducer from "./slices/favourite";
import authReducer from "./slices/auth";
import userReducer from "./slices/user";


// ----------------------------------------------------------------------
const rootPersistConfig = {
  keyPrefix: "redux-",
  key: "root",
  storage,
  // No need to specify whitelist if you want to persist all states
  // whitelist: [], 
};

const authPersistConfig = {
  keyPrefix: "redux-",
  key: "auth",
  storage,
  whitelist: [], // Or specify keys to persist if needed
};

const rootReducer = combineReducers({
  app: appReducer,
  filter: filterReducer,
  favorites: favoritesReducer,
  user: userReducer,
  auth: persistReducer(authPersistConfig, authReducer),
});

export { rootPersistConfig, rootReducer };
